<script setup lang="ts">
  import Main from "./components/Main.vue";
  import InstallPWA from './views/Utilities/InstallPWA.vue'
  import UpdatePWA from './views/Utilities/UpdatePWA.vue'
  import GlobalModal from './components/Modal/GlobalModal.vue'
  import CompteursView from './views/Compteurs/CompteursView.vue'

</script>

<template>
  <Main/>
  <InstallPWA/>
  <UpdatePWA/>
  <GlobalModal :title="$t('compteur.shortcutTitle')" shortcut="F2" fullscreen>
    <CompteursView />
  </GlobalModal>
</template>

<style>
@import "@/assets/css/main.css";
@import "@/assets/css/style.css";

body {
  margin: 0;
  height: auto;
  /* Repris de #app ci-dessous : hérité par tout ce qui est monté hors de #app
     (modales en append-to-body, ex. actions ATE), qui sinon retombe sur la
     police système par défaut du navigateur. */
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    "Open Sans",
    "Helvetica Neue",
    sans-serif;
}
#app {
  font-size: large;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
